/* eslint-disable react/display-name */
import { Link as GatsbyLink } from 'gatsby';
import { GatsbyLinkProps } from 'gatsby';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { generateNewTranslatedUrl } from '../../utils/i18n/route-translations';
import { forwardRef } from 'react';

// TODO: check types
const Link = forwardRef<HTMLAnchorElement, GatsbyLinkProps<{}>>(({ children, to, activeClassName, partiallyActive, ...other }, ref) => {
  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(to)
  // Use Gatsby Link for internal links, and <a> for others
  // react-i18next wrapper
  const { language } = useI18next();
  if (internal) {
    const { url } = generateNewTranslatedUrl(to, language, language);

    return (
      <GatsbyLink
        ref={ref}
        to={url}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        {...other}
      >
        {children}
      </GatsbyLink>
    )
  }
  return (
    <a
      ref={ref}
      href={to}
      rel="noopener noreferrer"
      {...other}
    >
      {children}
    </a>
  )
})

export default Link;
